import { HTMLAttributes } from "react";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import { FaRegFileExcel } from "react-icons/fa";

import "./styles.css";

type Props = HTMLAttributes<HTMLButtonElement> & {
	disabledExportButton?: boolean;
};

export function ExportExcelButton({ disabledExportButton, ...rest }: Props) {
	return (
		<OverlayTrigger overlay={<Tooltip>Exportar excel</Tooltip>}>
			<button
				type="button"
				id="export-excel-button"
				className="btn fs-3 px-4 py-1"
				disabled={disabledExportButton}
				{...rest}
			>
				<FaRegFileExcel />
			</button>
		</OverlayTrigger>
	);
}
